import React from 'react'
import { Box, Boxes } from '../../../../layout/box'
import Empty from '../../components/empty'
import RecItems from '../rec-items/type1'
import CartUnpaidOrder from '../unpaid-order'

export default props => {

    const { recs } = props

    return <Boxes>
        <Box>
            <Empty />
        </Box>

        <CartUnpaidOrder />

        {
            recs?.length > 0 && <Box>
                <RecItems recs={recs} />
            </Box>
        }
    </Boxes>
}